import PropTypes from 'prop-types';
import { Button, Image } from 'react-bootstrap';
import { StepText } from 'components';
import { VARIANTS } from './config';
import './styles.scss';

export default function BigActionCard({
  title,
  description,
  image,
  altImage,
  number,
  actionLabel = '',
  onAction,
  variant = '',
  className = '',
}) {
  const hasSeparate = variant === VARIANTS.SEPARATE;

  const cardTitle = (
    <StepText
      className={`${hasSeparate ? 'justify-content-start mb-4' : ''}`}
      number={number}
      title={title}
    />
  );

  return (
    <div className="d-flex justify-content-center align-items-center flex-column">
      {hasSeparate && <div className="">{cardTitle}</div>}

      <div
        className={`BigActionCard d-flex justify-content-between flex-column align-items-center ${className}`}
      >
        {variant !== VARIANTS.SEPARATE && cardTitle}

        <div className="BigActionCard__controls d-flex flex-column align-items-center">
          <Image src={image} className="my-4" alt={altImage} />

          {description && (
            <p className="BigActionCard__description m-0 mb-3 p-0">
              {description}
            </p>
          )}

          <Button
            className="mt-2"
            block
            variant="secondary"
            type="button"
            onClick={onAction}
          >
            {actionLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}

BigActionCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  altImage: PropTypes.string,
  number: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  variant: PropTypes.string,
};
